<template>
  <b-button
    :variant="variant"
    :disabled="isLoading"
    class="d-flex align-items-center justify-content-between h-100 p-0"
    block
    @click="$emit('click')"
  >
    <template v-if="!isLoading">
      <b-col lg="3">
        <template v-if="icon === 'pause'">
          <icon name="pause-circle" scale="2" />
        </template>
        <i v-else :class="`ti ti-fw ti-2x ${icon}`" />
      </b-col>
      <b-col class="d-none d-lg-flex">
        <span class="ml-3 text-left">
          {{ text }}
        </span>
      </b-col>
    </template>
    <b-col v-else cols="12" class="text-center">
      <i class="ti ti-spin ti-refresh" />
    </b-col>
  </b-button>
</template>

<script>
  // eslint-disable-next-line import/no-extraneous-dependencies
  import 'vue-awesome/icons/pause-circle';

  export default {
    name: 'ButtonWithIconComponent',
    props: {
      variant: {
        type: String,
        default: 'info',
      },
      icon: {
        type: String,
        default: 'ti-info',
      },
      text: {
        type: String,
        default: null,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
</style>
